var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('input-row', {
    attrs: {
      "label": _vm.label
    }
  }, [_c('div', {
    staticClass: "form-file-box",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('v-file-input', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: _vm.temp,
      callback: function callback($$v) {
        _vm.temp = $$v;
      },
      expression: "temp"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto",
      "sm": "2"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 h-100 input-btn",
    attrs: {
      "block": "",
      "elevation": "0",
      "dark": "",
      "color": "grey-dark"
    },
    on: {
      "click": _vm.addFile
    }
  }, [_vm._v("첨부")])], 1)], 1), _c('v-chip-group', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.value, function (file, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "value": file
      }
    }, [_c('span', [_vm._v(_vm._s(file.name))]), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-close")])], 1);
  }), 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }